module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.away),
      expression: "away"
    }],
    staticClass: "dropdown is-right",
    class: {
      'is-active': _vm.show_dropdown
    },
    attrs: {
      "id": "client-list"
    }
  }, [_c('div', {
    staticClass: "dropdown-trigger",
    on: {
      "click": function($event) {
        _vm.show_dropdown = !_vm.show_dropdown
      }
    }
  }, [_c('span', {
    staticClass: "mdl-chip mdl-chip--deletable"
  }, [_c('span', {
    staticClass: "mdl-chip__text"
  }, [(_vm.selected_client.id) ? _c('span', [_vm._v(_vm._s(_vm.selected_client.id) + "  ")]) : _c('span', [_vm._v("Ny klient  ")])]), _c('span', {
    staticClass: "mdl-chip__action"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_dropdown),
      expression: "!show_dropdown"
    }],
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_down")]), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show_dropdown),
      expression: "show_dropdown"
    }],
    staticClass: "material-icons"
  }, [_vm._v("keyboard_arrow_up")])])])]), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-content"
  }, [_c('div', {
    staticClass: "dropdown-item menu-label",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Aktiva - " + _vm._s(_vm.active_list.length) + " st")]), _vm._l((_vm.active_list), function(client, index) {
    return _c('a', {
      key: client.uid,
      staticClass: "dropdown-item",
      class: {
        'is-active': _vm.selected_client.uid == client.uid
      },
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          _vm.select(client)
        }
      }
    }, [_vm._v(_vm._s(client.id))])
  }), _c('hr', {
    staticClass: "dropdown-divider"
  }), _c('a', {
    staticClass: "dropdown-item menu-label"
  }, [_vm._v("Avslutade")]), _vm._l((_vm.unactive_list), function(clients, year) {
    return _c('div', {
      key: year
    }, [_c('a', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          _vm.clickYear(year)
        }
      }
    }, [_vm._v(_vm._s(year) + " - " + _vm._s(clients.length) + " st  "), _c('span', {
      staticClass: "icon toggle",
      class: {
        down: _vm.show_year == year
      }
    }, [_vm._v("▸")])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.show_year == year),
        expression: "show_year == year"
      }],
      staticStyle: {
        "margin-left": "1em"
      }
    }, _vm._l((clients), function(client) {
      return _c('a', {
        staticClass: "dropdown-item",
        class: {
          'is-active': _vm.selected_client.uid == client.uid
        },
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            _vm.select(client)
          }
        }
      }, [_vm._v(_vm._s(client.id))])
    }))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05c41db0","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientList.vue
// module id = 500
// module chunks = 1